import { useEffect, useRef } from 'react';

const IDLE_TIMEOUT = 3000;

interface UseIdleTimerOptions {
    enabled: boolean;
    setIdle: (idle: boolean) => void;
}

function useIdleTimer({ enabled, setIdle }: UseIdleTimerOptions) {
    const idleTimer = useRef<number>();

    useEffect(() => {
        function resetTimer() {
            setIdle(false);
            window.clearTimeout(idleTimer.current);
            idleTimer.current = window.setTimeout(() => setIdle(true), IDLE_TIMEOUT);
        }

        if (enabled) {
            window.addEventListener('mousemove', resetTimer, true);
            window.addEventListener('keypress', resetTimer, true);
            window.addEventListener('click', resetTimer, true);
        }

        return () => {
            window.clearTimeout(idleTimer.current);
            window.removeEventListener('mousemove', resetTimer);
            window.removeEventListener('keypress', resetTimer);
            window.removeEventListener('click', resetTimer);
        };
    }, [enabled, setIdle, idleTimer]);
}
export default useIdleTimer;
